"use strict";

class SalesApplicationAddSaleDiscountsController {

  constructor($scope, $window, $timeout, $localStorage, SSHttpService, SSUtilService, SSConfigService, SSAppService, SSUserService, SSAlertService, SSEoiService, SSSaleDiscountsService, SSEoiDiscountsService, SSConfirmationService) {
    const self = this;

    self.$scope = $scope;
    self.$window = $window;
    self.$timeout = $timeout;
    self.$storage = $localStorage;

    self.SSHttpService = SSHttpService;
    self.SSUtilService = SSUtilService;
    self.SSConfigService = SSConfigService;
    self.SSAppService = SSAppService;
    self.SSUserService = SSUserService;
    self.SSAlertService = SSAlertService;
    self.SSEoiService = SSEoiService;
    self.SSSaleDiscountsService = SSSaleDiscountsService;
    self.SSEoiDiscountsService = SSEoiDiscountsService;
    self.SSConfirmationService = SSConfirmationService;

    self.PROPERTY_TYPE_PRIVATE_CONDO = 1;
    self.PROPERTY_TYPE_EXECUTIVE_CONDO = 2;
    self.PROPERTY_TYPE_LANDED = 3;
    self.PROPERTY_TYPE_APARTMENT = 4;
    self.PROPERTY_TYPE_INTERGATED_DEVELOPMENT = 5;
    self.PROPERTY_TYPE_COMMERCIAL = 6;

    // UNIT_STATUS_DRAFT = 10; // just created not listed
    // UNIT_STATUS_LISTED = 20; // listing and ready for sale to public
    // UNIT_STATUS_RESERVED = 30; // booknow session in-progress
    // UNIT_STATUS_BOOKED = 40; // dealing in process
    // UNIT_STATUS_SOLD = 50;
    // UNIT_STATUS_SPECIAL_RESERVED = 60;// Long time reserved

    self.UNIT_STATUS_DRAFT = SHOWSUITE.UNIT_STATUS_DRAFT;
    self.UNIT_STATUS_LISTED = SHOWSUITE.UNIT_STATUS_LISTED;
    self.UNIT_STATUS_RESERVED = SHOWSUITE.UNIT_STATUS_RESERVED;
    self.UNIT_STATUS_BOOKED = SHOWSUITE.UNIT_STATUS_BOOKED;
    self.UNIT_STATUS_SOLD = SHOWSUITE.UNIT_STATUS_SOLD;
    self.UNIT_STATUS_SPECIAL_RESERVED = SHOWSUITE.UNIT_STATUS_SPECIAL_RESERVED;

    self.DISCOUNT_TYPE_STANDARD = SHOWSUITE.DISCOUNT_TYPE_STANDARD; 
    self.DISCOUNT_TYPE_STAFF = SHOWSUITE.DISCOUNT_TYPE_STAFF;
    self.DISCOUNT_TYPE_PROMO_CODE_SINGLE_USE = SHOWSUITE.DISCOUNT_TYPE_PROMO_CODE_SINGLE_USE;
    self.DISCOUNT_TYPE_PROMO_CODE_MULTIPLE_USE = SHOWSUITE.DISCOUNT_TYPE_PROMO_CODE_MULTIPLE_USE;
    self.DISCOUNT_TYPE_PROMO_CODE_OTHER = SHOWSUITE.DISCOUNT_TYPE_PROMO_CODE_OTHER
    self.DISCOUNT_TYPE_PROMO_CODE_ADDITIONAL = SHOWSUITE.DISCOUNT_TYPE_PROMO_CODE_ADDITIONAL;

    self.DISCOUNT_TYPE_AMOUNT = 1;
    self.DISCOUNT_TYPE_PERCENTAGE = 2;

    self.VALUE_TYPE_PERCENTAGE = SHOWSUITE.VALUE_TYPE_PERCENTAGE;
    self.VALUE_TYPE_AMOUNT = SHOWSUITE.VALUE_TYPE_AMOUNT;

    self.init();
  }

  init(){
    const self = this;

    self.user = self.SSUserService.getUser();
    if (!self.user) {
      self.SSUserService.showLoginModal();
    }
  }

  onAddPromoCode(){
    const self = this;

    if(!self.promo_code){
      self.error = true;
      self.promoCodeFieldError = "Please enter a valid promo code";
    }
    else{
      self.validatePromoCode();
    }
  }

  validatePromoCode(){
    const self = this;

    // Check if promo code is correct
    let unit_id = self.promo_code_unit.id;
    let url = 'sec/promotion-code/check-eoi';

    let params = {
      id: self.eoi.id,
      unit_id: unit_id,
      code: self.promo_code,
    };

    loading(true);
    self.SSHttpService.getAPIRequest(url, params).then(function (response) {
      loading(false);
      self.hideModals();
      if (response instanceof Error) {
        if(response.code == 404){
          self.showPromoCodeMessage("Promo code applied is invalid", true);
          return;
        }
        else{
          self.SSAlertService.parseAndDisplayError(response);
          return;
        }
      }
      
      if(response.data && response.data.eoi){
        self.preparePromoCodeByUnitId(response.data);
        self.showPromoCodeMessage("Promo code successfully applied", false);
      }
      else{
        self.showPromoCodeMessage("Promo code applied is invalid", true);
      }
 
    });
  }

  showPromoCodeMessage(message, isError){
    const self = this;

    self.error = isError;  
    self.info_message = message;
    self.showInfoModal = true;
    $('#infoMessageModal').modal('show');     
  }

  onInfoMessage(){
    const self = this;
    
    self.hideModals();
  }

  resetPromoCodeFields(){
    const self = this;

    self.promoCodeFieldError = "";
    self.promo_code = "";
    self.error = false;
  }

  getUnitNumber(unit){
    const self = this;

    if(unit.length < 1){
      return '-';
    }
    return self.SSUtilService.getFullUnitNumber1(unit, false);
  }

  showDiscountModal(eoiUnit) {
        const self = this;

        self.selected_unit_discount = eoiUnit;

        self.add_discount_error = {};
        self.add_discount = {};
        self.selected_discount = null;

        self.availablePropertyDiscounts = [];

        $.each(self.SSEoiService.all_property_discounts, function (index, propertyDiscount) {
            if (!(self.SSEoiDiscountsService.isActiveDiscount(propertyDiscount))) return; // Skip if not active
            if (propertyDiscount.marketing_scheme && propertyDiscount.marketing_scheme !== self.SSEoiService.sale_obj.marketing_scheme) return; // Skip if different Marketing Scheme
            if (!(self.SSEoiDiscountsService.isDiscountApplicable(eoiUnit.id, propertyDiscount))) return; // Skip. This will only apply to assigned units
            if (eoiUnit.applied_discounts.find(x => x.property_discount_id === propertyDiscount.id)) return; // Skip if its already applied

            self.availablePropertyDiscounts.push(propertyDiscount);
        });

        self.displayDiscountModal = true;
        let m = $('#saleApplicationAddDiscountModal');
        if (!(m.is(':visible'))) m.modal('show');
  }

  onAddDiscount(discount, unit = null, callback = null) {
        const self = this;

        if (!self.validateDiscount(discount)) {
            return;
        }

        // Check if discount available for selected unit
        if (!self.SSEoiDiscountsService.isDiscountApplicable(unit? unit.id : self.selected_unit_discount.id, discount)) {
            self.SSAlertService.warning("Warning!", "This discount is not available for selected unit.");
            self.hideDiscountModal();
            return;
        }

        let url = 'sec/sales/' + self.SSEoiService.sale_obj.id + '/discounts/' + discount.id + '/apply';
        let params = {
            unit_id: unit? unit.id : self.selected_unit_discount.id,
            code: discount.code,
            remarks: discount.remarks,
            response_type: 1
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(unit? true : false);
            if (response instanceof Error) {
                loading(false);
                if (response.data.code) {
                    self.add_discount_error.code = response.data.code[0];
                } else {
                    self.SSAlertService.parseAndDisplayError(response);
                }

                return;
            }
            self.hideDiscountModal();

            if (response.data.sale_discounts) {
                $.each(response.data.sale_discounts, function (i, saleDiscount) {
                    if (!(self.SSEoiService.sale_obj.sale_discounts)
                        || !(self.SSEoiService.sale_obj.sale_discounts.find(x => x.id === saleDiscount.id))
                    ) {

                        if(!self.SSEoiService.sale_obj.hasOwnProperty("sale_discounts"))
                          self.SSEoiService.sale_obj.sale_discounts = [];

                        self.SSEoiService.sale_obj.sale_discounts.push(saleDiscount);
                    }
                });
            }

            self.linkEoiDiscountsWithPropertyDiscounts();
            self.prepareEoiUnitAppliedDiscounts();
            self.calculateUnitSalePrice(unit? unit : self.selected_unit_discount);

            if(callback){
              callback(response);
            }
      });
  }

  hideDiscountModal() {
      const self = this;

      self.displayDiscountModal = false;
      let m = $('#saleApplicationAddDiscountModal');
      if (m.is(':visible')) m.modal('hide');
  }

  calculateUnitSalePrice(eoiUnit) {
        const self = this;

        let totalDiscount = 0;

        if (eoiUnit.applied_discounts) {
            // $.each(eoiUnit.applied_discounts, function (index, eoiDiscount) {
            //     if (eoiDiscount.property_discount
            //         && !(self.isDiscountType1(eoiDiscount.property_discount.type))
            //     ) {
            //         return; // Ignore, Type 2 discount that should not be subtracted from sale price
            //     }
            //     totalDiscount += eoiDiscount.discounted_amount;
            // });
            $.each(eoiUnit.applied_discounts, function (index, eoiDiscount) {
                if (!(self.isDiscountType1(eoiDiscount.type))
                ) {
                    return; // Ignore, Type 2 discount that should not be subtracted from sale price
                }
                totalDiscount += eoiDiscount.discounted_amount;
            });
        }

        eoiUnit.final_discount = totalDiscount; // Math.round(totalDiscount);
        eoiUnit.final_sale_price = eoiUnit.price - eoiUnit.final_discount; // Math.max(eoiUnit.price - eoiUnit.final_discount, 0);
    
        self.SSEoiService.sale_obj.price = eoiUnit.final_sale_price;
  }

  // Checks the discount type whether it will affect the price or not
  isDiscountType1(type) {
      const self = this;

      return type === self.DISCOUNT_TYPE_STANDARD ||
          type === self.DISCOUNT_TYPE_STAFF ||
          type === self.DISCOUNT_TYPE_PROMO_CODE_SINGLE_USE ||
          type === self.DISCOUNT_TYPE_PROMO_CODE_MULTIPLE_USE ||
          type === self.DISCOUNT_TYPE_PROMO_CODE_OTHER ||
          type === self.DISCOUNT_TYPE_PROMO_CODE_ADDITIONAL;
  }

  linkEoiDiscountsWithPropertyDiscounts() {
        const self = this;

        if (!(self.SSEoiService.sale_obj && self.SSEoiService.sale_obj.sale_discounts && self.SSEoiService.all_property_discounts)) return; // Skip, missing data

        $.each(self.SSEoiService.sale_obj.sale_discounts, function (index, discount) {
            discount.property_discount = self.SSEoiService.all_property_discounts.find(x => x.id === discount.property_discount_id);
        });
  }

  prepareEoiUnitAppliedDiscounts() {
        const self = this;

        if (!(self.SSEoiService.sale_obj && self.SSEoiService.sale_obj.selected_units)) return; // Skip, missing data

        // Reset applied_discounts in SaleUnits
        $.each(self.SSEoiService.sale_obj.selected_units, function (index, unit) {
            unit.applied_discounts = [];
        });

        $.each(self.SSEoiService.sale_obj.sale_discounts, function (index, saleDiscount) {
            // let unit = self.SSEoiService.sale_obj.selected_units.find(x => x.id === saleDiscount.unit_id);
            // if (!unit) return; // Skip

            if (!(self.selected_unit_discount.applied_discounts.find(x => x.id === saleDiscount.id))) {
                self.selected_unit_discount.applied_discounts.push(saleDiscount);
            }
        });
  }

  getFieldVisibility(type) {
        const self = this;

        if (!type) {
            return false;
        }

        if (type == self.DISCOUNT_TYPE_STAFF
            || type == self.DISCOUNT_TYPE_PROMO_CODE_SINGLE_USE
            || type == self.DISCOUNT_TYPE_PROMO_CODE_MULTIPLE_USE
            || type == self.DISCOUNT_TYPE_PROMO_CODE_OTHER
            || type == self.DISCOUNT_TYPE_PROMO_CODE_ADDITIONAL) {
            return true;
        } else {
            if (!self.add_discount) self.add_discount = {};
            self.add_discount.code = null;

            return false;
        }
  }

  getFieldLabel(type) {
        const self = this;

        if (!type) {
            return false;
        }

        if (type == self.DISCOUNT_TYPE_STAFF) {
            return 'Staff ID';
        } else if (type == self.DISCOUNT_TYPE_PROMO_CODE_SINGLE_USE
            || type == self.DISCOUNT_TYPE_PROMO_CODE_MULTIPLE_USE
            || type == self.DISCOUNT_TYPE_PROMO_CODE_OTHER
            || type == self.DISCOUNT_TYPE_PROMO_CODE_ADDITIONAL) {
            return 'Code';
        } else {
            self.selected_discount.code = null;
            return 'Code';
        }
  }

  removeDiscount(discount, unit) {
      const self = this;

      if (discount.type === self.DISCOUNT_TYPE_STANDARD) {
          self.SSAlertService.danger("Error.", "Unable to remove Standard Discount from this sale.");
          return;
      }

      self.SSConfirmationService.getConfirmed(
          'Confirm!',
          'Are you sure you want to remove the applied discount?',
          self.SSConfirmationService.TYPE_DEFAULT,
          function () {
              let url = 'sec/sales/' + self.SSEoiService.sale_obj.id + '/discounts/' + discount.property_discount_id + '/delete';
              let params = {
                  unit_id: unit.id
              };

              loading(true);
              self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                  loading(false);
                  if (response instanceof Error) {
                      self.SSAlertService.parseAndDisplayError(response);
                      return;
                  }

                  // self.selectedEoi.eoi_discounts = self.selectedEoi.eoi_discounts.filter(x => x.id !== discount.id);
                  unit.applied_discounts = unit.applied_discounts.filter(x => x.id !== discount.id);

                  self.calculateUnitSalePrice(unit);
              });
      });
  }


  isActiveDiscount(property_discount){
    const self = this;

    if (property_discount.is_active) {
      let start_date = moment(property_discount.availability_start_date);
      let end_date = moment(property_discount.availability_end_date);
      let today_date = moment();

      if (end_date.isSameOrAfter(today_date, 'day') && today_date.isSameOrAfter(start_date, 'day')) {
        return true;
      }
      else{
        return false;
      }
    }
    else{
      return false;
    }
  }

  updateDiscountNames(discount){
    const self = this;

    self.add_discount_error.discount = "";

    if(!discount){
      return;
    }

    let _property_discount_names = self.SSEoiService.property_discount_names[discount.type];
    self.discount_names = [];

    if(_property_discount_names && _property_discount_names.length > 0){
      $.each(_property_discount_names, function(index, obj){
        self.discount_names.push(obj);
        // if(self.isActiveDiscount(obj.discount)){
        //   self.discount_names.push(obj);
        // }
      });
    }
  }

  validateDiscount(discount) {
        const self = this;

        self.add_discount_error = {};

        let isValid = true;

        //if (!self.add_discount || _.isEmpty(self.add_discount)) {
        //    self.add_discount_error.discount = "Please select discount."
        //    isValid = false;
        //}

        if (!discount || !discount.id) {
            self.add_discount_error.type = "Please select discount."
            isValid = false;
        } else {
            if (!discount.code) {
                if (discount.type === self.DISCOUNT_TYPE_PROMO_CODE_SINGLE_USE
                    || discount.type === self.DISCOUNT_TYPE_PROMO_CODE_MULTIPLE_USE
                    || discount.type === self.DISCOUNT_TYPE_PROMO_CODE_OTHER
                    || discount.type === self.DISCOUNT_TYPE_PROMO_CODE_ADDITIONAL
                ) {
                    self.add_discount_error.code = "Please enter discount code.";
                    isValid = false;
                } else if (discount.type === self.DISCOUNT_TYPE_STAFF) {
                    self.add_discount_error.code = "Please enter Staff ID.";
                    isValid = false;
                }
            }
        }

        // if (self.add_discount.type === self.DISCOUNT_TYPE_STAFF) {
        //   if (!self.add_discount.remarks || self.add_discount.remarks == "" || self.add_discount.remarks == null) {
        //     self.add_discount_error.remarks = "Please enter Staff ID";
        //     return false;
        //   }
        // }

        return isValid;
  }

  recalculateDiscount(unit) {
    const self = this;

    let totalDiscountedAmount = 0;

    $.each(unit.applied_discounts, function(index, discount) {
      // Check the discount type whether it will affect the price or not
      if (discount.type === self.DISCOUNT_TYPE_STANDARD ||
          discount.type === self.DISCOUNT_TYPE_STAFF ||
          discount.type === self.DISCOUNT_TYPE_PROMO_CODE_SINGLE_USE ||
          discount.type === self.DISCOUNT_TYPE_PROMO_CODE_MULTIPLE_USE ||
          discount.type === self.DISCOUNT_TYPE_PROMO_CODE_OTHER ||
          discount.type === self.DISCOUNT_TYPE_PROMO_CODE_ADDITIONAL
      ) {
        totalDiscountedAmount += discount.discounted_amount;
      }
    });

    unit.final_discount = totalDiscountedAmount;
    unit.final_sale_price = unit.price - unit.final_discount;

    // Update this price in sale object
    if(unit.final_sale_price){
      self.SSEoiService.sale_obj.price = unit.final_sale_price;
    }
  }

  removeUsedDiscount(discount) {
    const self = this;

    try{
      self.SSEoiService.all_property_discounts = self.SSEoiService.all_property_discounts.filter(x => x.id != discount.property_discount_id);
    }
    catch(ex){
      console.log(ex);
    }
  }

  proceedPDIPage() {
    loading(false);
    const self = this;
    self.SSEoiService.currentPage = self.SSEoiService.LAUNCH_PDI_PAGE;
    self.SSAlertService.message = null;
  }

  hideModals() {
    const self = this;

    self.displayDiscountModal = false;

    if ($('#infoMessageModal').is(':visible')) $('#infoMessageModal').modal('hide');
    if ($('#saleApplicationAddDiscountModal').is(':visible')) $('#saleApplicationAddDiscountModal').modal('hide');
  }
}

SalesApplicationAddSaleDiscountsController.$inject = ['$scope', '$window', '$timeout', '$localStorage', 'SSHttpService', 'SSUtilService', 'SSConfigService', 'SSAppService', 'SSUserService', 'SSAlertService', 'SSEoiService', 'SSSaleDiscountsService', 'SSEoiDiscountsService', 'SSConfirmationService'];
app.controller('SalesApplicationAddSaleDiscountsController', SalesApplicationAddSaleDiscountsController);